import i18next from 'i18next'
import {injectable} from 'inversify'
import {BaseFilterContainerStore} from '@/stores/shared'
import {FilterFormFieldType} from '@/types'
import {makeObservable} from 'mobx'
import {PayByLinkFilterType} from '@/stores/pay-by-link/models/PayByLinkFilterType'
@injectable()
export class PayByLinkFilterStore extends BaseFilterContainerStore<PayByLinkFilterType> {
    constructor() {
        super()

        makeObservable(this, {
            ...super.getAnnotationsMap()
        })
    }

    getInitialFilter(): Partial<PayByLinkFilterType> {
        return {
            initiatorEmail: null,
            description: null,
            customerName: null,
            type: null
        }
    }

    getFilterForBackend(): Partial<PayByLinkFilterType> {
        return this._filter
    }

    get filter() {
        return {
            ...this._filter
        }
    }

    get fields(): FilterFormFieldType[] {
        return [
            {
                name: 'customerName',
                label: i18next.t('pay-by-link.customerName'),
                placeholder: i18next.t('pay-by-link.customerName'),
                type: 'input'
            },
            {
                name: 'initiatorEmail',
                label: i18next.t('pay-by-link.createdBy'),
                placeholder: i18next.t('pay-by-link.email'),
                type: 'input'
            },
            {
                name: 'description',
                label: i18next.t('pay-by-link.description'),
                placeholder: i18next.t('pay-by-link.description'),
                type: 'input'
            },
            {
                name: 'type',
                label: i18next.t('PayByLink.type'),
                type: 'select',
                data: {
                    options: [
                        {
                            value: null,
                            label: i18next.t('globals:filter.all')
                        },
                        {
                            value: 'oneTime',
                            label: i18next.t('PayByLink.oneTime')
                        },
                        {
                            value: 'multiUse',
                            label: i18next.t('PayByLink.multiUse')
                        }
                    ]
                }
            }
        ]
    }
}
